import { get } from 'lodash';
import { DiagnosticReportValidationTypes } from '../enums/diagnosticReportValidationTypes';
import { ReportCategories } from '../enums/reportCategories';
import { ServiceCode } from '../enums/serviceCode';
import { ServiceType } from '../enums/serviceType';

const diagnosticReportValidationTypes = {
    [ServiceCode.TPC]: {
        [ServiceType.consultation]: {
            [ReportCategories.consultReport]: {
                add: {
                    draft: {
                        1: DiagnosticReportValidationTypes.tpcV1AddDraftDiagnosticReport,
                    },
                    final: {
                        1: DiagnosticReportValidationTypes.tpcV1AddFinalDiagnosticReport,
                    },
                },
                edit: {
                    draft: {
                        1: DiagnosticReportValidationTypes.tpcV1EditDraftDiagnosticReport,
                    },
                    final: {
                        1: DiagnosticReportValidationTypes.tpcV1EditFinalDiagnosticReport,
                    },
                },
            },
        },
    },
    [ServiceCode.TPO]: {
        [ServiceType.examination]: {
            [ReportCategories.examinationReport]: {
                add: {
                    draft: {
                        1: DiagnosticReportValidationTypes.tpoV1AddDraftDiagnosticReport,
                    },
                    final: {
                        1: DiagnosticReportValidationTypes.tpoV1AddFinalDiagnosticReport,
                    },
                },
                edit: {
                    draft: {
                        1: DiagnosticReportValidationTypes.tpoV1EditDraftDiagnosticReport,
                    },
                    final: {
                        1: DiagnosticReportValidationTypes.tpoV1EditFinalDiagnosticReport,
                    },
                },
            },
        },
    },
    [ServiceCode.TCOR]: {
        [ServiceType.examination]: {
            [ReportCategories.examinationReport]: {
                add: {
                    draft: {
                        1: DiagnosticReportValidationTypes.tcorV1AddDraftDiagnosticReport,
                    },
                    final: {
                        1: DiagnosticReportValidationTypes.tcorV1AddFinalDiagnosticReport,
                    },
                },
                edit: {
                    draft: {
                        1: DiagnosticReportValidationTypes.tcorV1EditDraftDiagnosticReport,
                    },
                    final: {
                        1: DiagnosticReportValidationTypes.tcorV1EditFinalDiagnosticReport,
                    },
                },
            },
        },
    },
    [ServiceCode.TCOH]: {
        [ServiceType.examination]: {
            [ReportCategories.examinationReport]: {
                add: {
                    draft: {
                        1: DiagnosticReportValidationTypes.tcohV1AddDraftDiagnosticReport,
                        2: DiagnosticReportValidationTypes.tcohV2AddDraftDiagnosticReport,
                    },
                    final: {
                        1: DiagnosticReportValidationTypes.tcohV1AddFinalDiagnosticReport,
                        2: DiagnosticReportValidationTypes.tcohV2AddFinalDiagnosticReport,
                    },
                },
                edit: {
                    draft: {
                        1: DiagnosticReportValidationTypes.tcohV1EditDraftDiagnosticReport,
                        2: DiagnosticReportValidationTypes.tcohV2EditDraftDiagnosticReport,
                    },
                    final: {
                        1: DiagnosticReportValidationTypes.tcohV1EditFinalDiagnosticReport,
                        2: DiagnosticReportValidationTypes.tcohV2EditFinalDiagnosticReport,
                    },
                },
            },
        },
    },
    [ServiceCode.TIECG]: {
        [ServiceType.examination]: {
            [ReportCategories.examinationReport]: {
                add: {
                    draft: {
                        1: DiagnosticReportValidationTypes.tiecgV1AddDraftDiagnosticReport,
                    },
                    final: {
                        1: DiagnosticReportValidationTypes.tiecgV1AddFinalDiagnosticReport,
                    },
                },
                edit: {
                    draft: {
                        1: DiagnosticReportValidationTypes.tiecgV1EditDraftDiagnosticReport,
                    },
                    final: {
                        1: DiagnosticReportValidationTypes.tiecgV1EditFinalDiagnosticReport,
                    },
                },
            },
        },
    },
    [ServiceCode.TCCr]: {
        [ServiceType.consultation]: {
            [ReportCategories.consultReport]: {
                add: {
                    draft: {
                        1: DiagnosticReportValidationTypes.tccrV1AddDraftDiagnosticReport,
                    },
                    final: {
                        1: DiagnosticReportValidationTypes.tccrV1AddFinalDiagnosticReport,
                    },
                },
                edit: {
                    draft: {
                        1: DiagnosticReportValidationTypes.tccrV1EditDraftDiagnosticReport,
                    },
                    final: {
                        1: DiagnosticReportValidationTypes.tccrV1EditFinalDiagnosticReport,
                    },
                },
            },
        },
    },
    [ServiceCode.TCCh]: {
        [ServiceType.consultation]: {
            [ReportCategories.consultReport]: {
                add: {
                    draft: {
                        1: DiagnosticReportValidationTypes.tcchV1AddDraftDiagnosticReport,
                    },
                    final: {
                        1: DiagnosticReportValidationTypes.tcchV1AddFinalDiagnosticReport,
                    },
                },
                edit: {
                    draft: {
                        1: DiagnosticReportValidationTypes.tcchV1EditDraftDiagnosticReport,
                    },
                    final: {
                        1: DiagnosticReportValidationTypes.tcchV1EditFinalDiagnosticReport,
                    },
                },
            },
        },
    },
    [ServiceCode.TCCi]: {
        [ServiceType.consultation]: {
            [ReportCategories.consultReport]: {
                add: {
                    draft: {
                        1: DiagnosticReportValidationTypes.tcciV1AddDraftDiagnosticReport,
                    },
                    final: {
                        1: DiagnosticReportValidationTypes.tcciV1AddFinalDiagnosticReport,
                    },
                },
                edit: {
                    draft: {
                        1: DiagnosticReportValidationTypes.tcciV1EditDraftDiagnosticReport,
                    },
                    final: {
                        1: DiagnosticReportValidationTypes.tcciV1EditFinalDiagnosticReport,
                    },
                },
            },
        },
    },
    [ServiceCode.OSASO]: {
        [ServiceType.examination]: {
            [ReportCategories.examinationReport]: {
                add: {
                    draft: {
                        1: DiagnosticReportValidationTypes.osasoV1AddDraftDiagnosticReport,
                    },
                    final: {
                        1: DiagnosticReportValidationTypes.osasoV1AddFinalDiagnosticReport,
                    },
                },
                edit: {
                    draft: {
                        1: DiagnosticReportValidationTypes.osasoV1EditDraftDiagnosticReport,
                    },
                    final: {
                        1: DiagnosticReportValidationTypes.osasoV1EditFinalDiagnosticReport,
                    },
                },
            },
        },
    },
    [ServiceCode.OSASVO]: {
        [ServiceType.examination]: {
            [ReportCategories.examinationReport]: {
                add: {
                    draft: {
                        1: DiagnosticReportValidationTypes.osasvoV1AddDraftDiagnosticReport,
                    },
                    final: {
                        1: DiagnosticReportValidationTypes.osasvoV1AddFinalDiagnosticReport,
                    },
                },
                edit: {
                    draft: {
                        1: DiagnosticReportValidationTypes.osasvoV1EditDraftDiagnosticReport,
                    },
                    final: {
                        1: DiagnosticReportValidationTypes.osasvoV1EditFinalDiagnosticReport,
                    },
                },
            },
        },
    },
    [ServiceCode.OSASC1]: {
        [ServiceType.consultation]: {
            [ReportCategories.consultReport]: {
                add: {
                    draft: {
                        1: DiagnosticReportValidationTypes.osasc1V1AddDraftDiagnosticReport,
                    },
                    final: {
                        1: DiagnosticReportValidationTypes.osasc1V1AddFinalDiagnosticReport,
                    },
                },
                edit: {
                    draft: {
                        1: DiagnosticReportValidationTypes.osasc1V1EditDraftDiagnosticReport,
                    },
                    final: {
                        1: DiagnosticReportValidationTypes.osasc1V1EditFinalDiagnosticReport,
                    },
                },
            },
        },
    },
    [ServiceCode.OSASC2]: {
        [ServiceType.consultation]: {
            [ReportCategories.consultReport]: {
                add: {
                    draft: {
                        1: DiagnosticReportValidationTypes.osasc2V1AddDraftDiagnosticReport,
                        2: DiagnosticReportValidationTypes.osasc2V2AddDraftDiagnosticReport,
                    },
                    final: {
                        1: DiagnosticReportValidationTypes.osasc2V1AddFinalDiagnosticReport,
                        2: DiagnosticReportValidationTypes.osasc2V2AddFinalDiagnosticReport,
                    },
                },
                edit: {
                    draft: {
                        1: DiagnosticReportValidationTypes.osasc2V1EditDraftDiagnosticReport,
                        2: DiagnosticReportValidationTypes.osasc2V2EditDraftDiagnosticReport,
                    },
                    final: {
                        1: DiagnosticReportValidationTypes.osasc2V1EditFinalDiagnosticReport,
                        2: DiagnosticReportValidationTypes.osasc2V2EditFinalDiagnosticReport,
                    },
                },
            },
        },
    },
    [ServiceCode.TFO]: {
        [ServiceType.examination]: {
            [ReportCategories.examinationReport]: {
                add: {
                    draft: {
                        1: DiagnosticReportValidationTypes.tfoV1AddDraftDiagnosticReport,
                    },
                    final: {
                        1: DiagnosticReportValidationTypes.tfoV1AddFinalDiagnosticReport,
                    },
                },
                edit: {
                    draft: {
                        1: DiagnosticReportValidationTypes.tfoV1EditDraftDiagnosticReport,
                    },
                    final: {
                        1: DiagnosticReportValidationTypes.tfoV1EditFinalDiagnosticReport,
                    },
                },
            },
        },
    },
    [ServiceCode.TOC]: {
        [ServiceType.consultation]: {
            [ReportCategories.consultReport]: {
                add: {
                    draft: {
                        1: DiagnosticReportValidationTypes.tocV1AddDraftDiagnosticReport,
                    },
                    final: {
                        1: DiagnosticReportValidationTypes.tocV1AddFinalDiagnosticReport,
                    },
                },
                edit: {
                    draft: {
                        1: DiagnosticReportValidationTypes.tocV1EditDraftDiagnosticReport,
                    },
                    final: {
                        1: DiagnosticReportValidationTypes.tocV1EditFinalDiagnosticReport,
                    },
                },
            },
        },
    },
    [ServiceCode.PILOT]: {
        [ServiceType.consultation]: {
            [ReportCategories.consultReport]: {
                add: {
                    draft: {
                        1: DiagnosticReportValidationTypes.pilotConsultationV1AddDraftDiagnosticReport,
                    },
                    final: {
                        1: DiagnosticReportValidationTypes.pilotConsultationV1AddFinalDiagnosticReport,
                    },
                },
                edit: {
                    draft: {
                        1: DiagnosticReportValidationTypes.pilotConsultationV1EditDraftDiagnosticReport,
                    },
                    final: {
                        1: DiagnosticReportValidationTypes.pilotConsultationV1EditFinalDiagnosticReport,
                    },
                },
            },
        },
        [ServiceType.examination]: {
            [ReportCategories.examinationReport]: {
                add: {
                    draft: {
                        1: DiagnosticReportValidationTypes.pilotExaminationV1AddDraftDiagnosticReport,
                    },
                    final: {
                        1: DiagnosticReportValidationTypes.pilotExaminationV1AddFinalDiagnosticReport,
                    },
                },
                edit: {
                    draft: {
                        1: DiagnosticReportValidationTypes.pilotExaminationV1EditDraftDiagnosticReport,
                    },
                    final: {
                        1: DiagnosticReportValidationTypes.pilotExaminationV1EditFinalDiagnosticReport,
                    },
                },
            },
        },
        [ServiceType.referral]: {
            [ReportCategories.intake]: {
                add: {
                    draft: {
                        1: DiagnosticReportValidationTypes.pilotReferralV1AddDraftIntakeDiagnosticReport,
                    },
                    final: {
                        1: DiagnosticReportValidationTypes.pilotReferralV1AddFinalIntakeDiagnosticReport,
                    },
                },
                edit: {
                    draft: {
                        1: DiagnosticReportValidationTypes.pilotReferralV1EditDraftIntakeDiagnosticReport,
                    },
                    final: {
                        1: DiagnosticReportValidationTypes.pilotReferralV1EditFinalIntakeDiagnosticReport,
                    },
                },
            },
            [ReportCategories.discharge]: {
                add: {
                    draft: {
                        1: DiagnosticReportValidationTypes.pilotReferralV1AddDraftDischargeDiagnosticReport,
                    },
                    final: {
                        1: DiagnosticReportValidationTypes.pilotReferralV1AddFinalDischargeDiagnosticReport,
                    },
                },
                edit: {
                    draft: {
                        1: DiagnosticReportValidationTypes.pilotReferralV1EditDraftDischargeDiagnosticReport,
                    },
                    final: {
                        1: DiagnosticReportValidationTypes.pilotReferralV1EditFinalDischargeDiagnosticReport,
                    },
                },
            },
        },
    },
    [ServiceCode.TOO]: {
        [ServiceType.examination]: {
            [ReportCategories.examinationReport]: {
                add: {
                    draft: {
                        1: DiagnosticReportValidationTypes.tooV1AddDraftDiagnosticReport,
                    },
                    final: {
                        1: DiagnosticReportValidationTypes.tooV1AddFinalDiagnosticReport,
                    },
                },
                edit: {
                    draft: {
                        1: DiagnosticReportValidationTypes.tooV1EditDraftDiagnosticReport,
                    },
                    final: {
                        1: DiagnosticReportValidationTypes.tooV1EditFinalDiagnosticReport,
                    },
                },
            },
        },
    },
    [ServiceCode.TOV]: {
        [ServiceType.referral]: {
            [ReportCategories.intake]: {
                add: {
                    draft: {
                        1: DiagnosticReportValidationTypes.tovV1AddIntakeDiagnosticReport,
                    },
                    final: {
                        1: DiagnosticReportValidationTypes.tovV1AddIntakeDiagnosticReport,
                    },
                },
                edit: {
                    draft: {
                        1: DiagnosticReportValidationTypes.tovV1EditIntakeDiagnosticReport,
                    },
                    final: {
                        1: DiagnosticReportValidationTypes.tovV1EditIntakeDiagnosticReport,
                    },
                },
            },
            [ReportCategories.discharge]: {
                add: {
                    draft: {
                        1: DiagnosticReportValidationTypes.tovV1AddDischargeDiagnosticReport,
                    },
                    final: {
                        1: DiagnosticReportValidationTypes.tovV1AddDischargeDiagnosticReport,
                    },
                },
                edit: {
                    draft: {
                        1: DiagnosticReportValidationTypes.tovV1EditDischargeDiagnosticReport,
                    },
                    final: {
                        1: DiagnosticReportValidationTypes.tovV1EditDischargeDiagnosticReport,
                    },
                },
            },
        },
    },
    [ServiceCode.TFC]: {
        [ServiceType.consultation]: {
            [ReportCategories.consultReport]: {
                add: {
                    draft: {
                        1: DiagnosticReportValidationTypes.tfcV1AddDraftDiagnosticReport,
                    },
                    final: {
                        1: DiagnosticReportValidationTypes.tfcV1AddFinalDiagnosticReport,
                    },
                },
                edit: {
                    draft: {
                        1: DiagnosticReportValidationTypes.tfcV1EditDraftDiagnosticReport,
                    },
                    final: {
                        1: DiagnosticReportValidationTypes.tfcV1EditFinalDiagnosticReport,
                    },
                },
            },
        },
    },
    [ServiceCode.GGZCt]: {
        [ServiceType.consultation]: {
            [ReportCategories.consultReport]: {
                add: {
                    draft: {
                        1: DiagnosticReportValidationTypes.ggzctV1AddDraftDiagnosticReport,
                    },
                    final: {
                        1: DiagnosticReportValidationTypes.ggzctV1AddFinalDiagnosticReport,
                    },
                },
                edit: {
                    draft: {
                        1: DiagnosticReportValidationTypes.ggzctV1EditDraftDiagnosticReport,
                    },
                    final: {
                        1: DiagnosticReportValidationTypes.ggzctV1EditFinalDiagnosticReport,
                    },
                },
            },
        },
    },
    [ServiceCode.GGZCf2f]: {
        [ServiceType.consultation]: {
            [ReportCategories.consultReport]: {
                add: {
                    draft: {
                        1: DiagnosticReportValidationTypes.ggzcf2fV1AddDraftDiagnosticReport,
                    },
                    final: {
                        1: DiagnosticReportValidationTypes.ggzcf2fV1AddFinalDiagnosticReport,
                    },
                },
                edit: {
                    draft: {
                        1: DiagnosticReportValidationTypes.ggzcf2fV1EditDraftDiagnosticReport,
                    },
                    final: {
                        1: DiagnosticReportValidationTypes.ggzcf2fV1EditFinalDiagnosticReport,
                    },
                },
            },
        },
    },
    [ServiceCode.GGZCtriage]: {
        [ServiceType.consultation]: {
            [ReportCategories.consultReport]: {
                add: {
                    draft: {
                        1: DiagnosticReportValidationTypes.ggzctriageV1AddDraftDiagnosticReport,
                    },
                    final: {
                        1: DiagnosticReportValidationTypes.ggzctriageV1AddFinalDiagnosticReport,
                    },
                },
                edit: {
                    draft: {
                        1: DiagnosticReportValidationTypes.ggzctriageV1EditDraftDiagnosticReport,
                    },
                    final: {
                        1: DiagnosticReportValidationTypes.ggzctriageV1EditFinalDiagnosticReport,
                    },
                },
            },
        },
    },
    [ServiceCode.GGZv]: {
        [ServiceType.referral]: {
            [ReportCategories.intake]: {
                add: {
                    draft: {
                        1: DiagnosticReportValidationTypes.ggzV1AddIntakeDiagnosticReport,
                    },
                    final: {
                        1: DiagnosticReportValidationTypes.ggzV1AddIntakeDiagnosticReport,
                    },
                },
                edit: {
                    draft: {
                        1: DiagnosticReportValidationTypes.ggzV1EditIntakeDiagnosticReport,
                    },
                    final: {
                        1: DiagnosticReportValidationTypes.ggzV1EditIntakeDiagnosticReport,
                    },
                },
            },
            [ReportCategories.discharge]: {
                add: {
                    draft: {
                        1: DiagnosticReportValidationTypes.ggzV1AddDischargeDiagnosticReport,
                    },
                    final: {
                        1: DiagnosticReportValidationTypes.ggzV1AddDischargeDiagnosticReport,
                    },
                },
                edit: {
                    draft: {
                        1: DiagnosticReportValidationTypes.ggzV1EditDischargeDiagnosticReport,
                    },
                    final: {
                        1: DiagnosticReportValidationTypes.ggzV1EditDischargeDiagnosticReport,
                    },
                },
            },
        },
    },
    [ServiceCode.GGZCg]: {
        [ServiceType.consultation]: {
            [ReportCategories.consultReport]: {
                add: {
                    draft: {
                        1: DiagnosticReportValidationTypes.ggzcgV1AddDraftDiagnosticReport,
                    },
                    final: {
                        1: DiagnosticReportValidationTypes.ggzcgV1AddFinalDiagnosticReport,
                    },
                },
                edit: {
                    draft: {
                        1: DiagnosticReportValidationTypes.ggzcgV1EditDraftDiagnosticReport,
                    },
                    final: {
                        1: DiagnosticReportValidationTypes.ggzcgV1EditFinalDiagnosticReport,
                    },
                },
            },
        },
    },
    [ServiceCode.GGZCmdo]: {
        [ServiceType.consultation]: {
            [ReportCategories.consultReport]: {
                add: {
                    draft: {
                        1: DiagnosticReportValidationTypes.ggzcmdoV1AddDraftDiagnosticReport,
                    },
                    final: {
                        1: DiagnosticReportValidationTypes.ggzcmdoV1AddFinalDiagnosticReport,
                    },
                },
                edit: {
                    draft: {
                        1: DiagnosticReportValidationTypes.ggzcmdoV1EditDraftDiagnosticReport,
                    },
                    final: {
                        1: DiagnosticReportValidationTypes.ggzcmdoV1EditFinalDiagnosticReport,
                    },
                },
            },
        },
    },
    [ServiceCode.GTC]: {
        [ServiceType.consultation]: {
            [ReportCategories.consultReport]: {
                add: {
                    draft: {
                        1: DiagnosticReportValidationTypes.gtcV1AddDraftDiagnosticReport,
                    },
                    final: {
                        1: DiagnosticReportValidationTypes.gtcV1AddFinalDiagnosticReport,
                    },
                },
                edit: {
                    draft: {
                        1: DiagnosticReportValidationTypes.gtcV1EditDraftDiagnosticReport,
                    },
                    final: {
                        1: DiagnosticReportValidationTypes.gtcV1EditFinalDiagnosticReport,
                    },
                },
            },
        },
    },
    [ServiceCode.GTO]: {
        [ServiceType.examination]: {
            [ReportCategories.examinationReport]: {
                add: {
                    draft: {
                        1: DiagnosticReportValidationTypes.gtoV1AddDraftDiagnosticReport,
                    },
                    final: {
                        1: DiagnosticReportValidationTypes.gtoV1AddFinalDiagnosticReport,
                    },
                },
                edit: {
                    draft: {
                        1: DiagnosticReportValidationTypes.gtoV1EditDraftDiagnosticReport,
                    },
                    final: {
                        1: DiagnosticReportValidationTypes.gtoV1EditFinalDiagnosticReport,
                    },
                },
            },
        },
    },
    [ServiceCode.DermaC]: {
        [ServiceType.consultation]: {
            [ReportCategories.consultReport]: {
                add: {
                    draft: {
                        1: DiagnosticReportValidationTypes.dermaCV1AddDraftDiagnosticReport,
                    },
                    final: {
                        1: DiagnosticReportValidationTypes.dermaCV1AddFinalDiagnosticReport,
                    },
                },
                edit: {
                    draft: {
                        1: DiagnosticReportValidationTypes.dermaCV1EditDraftDiagnosticReport,
                    },
                    final: {
                        1: DiagnosticReportValidationTypes.dermaCV1EditFinalDiagnosticReport,
                    },
                },
            },
        },
    },
    [ServiceCode.DermaSnelC]: {
        [ServiceType.consultation]: {
            [ReportCategories.consultReport]: {
                add: {
                    draft: {
                        1: DiagnosticReportValidationTypes.dermaSnelCV1AddDraftDiagnosticReport,
                    },
                    final: {
                        1: DiagnosticReportValidationTypes.dermaSnelCV1AddFinalDiagnosticReport,
                    },
                },
                edit: {
                    draft: {
                        1: DiagnosticReportValidationTypes.dermaSnelCV1EditDraftDiagnosticReport,
                    },
                    final: {
                        1: DiagnosticReportValidationTypes.dermaSnelCV1EditFinalDiagnosticReport,
                    },
                },
            },
        },
    },
    [ServiceCode.DermaCsc]: {
        [ServiceType.consultation]: {
            [ReportCategories.consultReport]: {
                add: {
                    draft: {
                        1: DiagnosticReportValidationTypes.dermaCscV1AddDraftDiagnosticReport,
                    },
                    final: {
                        1: DiagnosticReportValidationTypes.dermaCscV1AddFinalDiagnosticReport,
                    },
                },
                edit: {
                    draft: {
                        1: DiagnosticReportValidationTypes.dermaCscV1EditDraftDiagnosticReport,
                    },
                    final: {
                        1: DiagnosticReportValidationTypes.dermaCscV1EditFinalDiagnosticReport,
                    },
                },
            },
        },
    },
    [ServiceCode.DermaSnelCsc]: {
        [ServiceType.consultation]: {
            [ReportCategories.consultReport]: {
                add: {
                    draft: {
                        1: DiagnosticReportValidationTypes.dermaSnelCscV1AddDraftDiagnosticReport,
                    },
                    final: {
                        1: DiagnosticReportValidationTypes.dermaSnelCscV1AddFinalDiagnosticReport,
                    },
                },
                edit: {
                    draft: {
                        1: DiagnosticReportValidationTypes.dermaSnelCscV1EditDraftDiagnosticReport,
                    },
                    final: {
                        1: DiagnosticReportValidationTypes.dermaSnelCscV1EditFinalDiagnosticReport,
                    },
                },
            },
        },
    },
    [ServiceCode.DermaCwond]: {
        [ServiceType.consultation]: {
            [ReportCategories.consultReport]: {
                add: {
                    draft: {
                        1: DiagnosticReportValidationTypes.dermaCwondV1AddDraftDiagnosticReport,
                    },
                    final: {
                        1: DiagnosticReportValidationTypes.dermaCwondV1AddFinalDiagnosticReport,
                    },
                },
                edit: {
                    draft: {
                        1: DiagnosticReportValidationTypes.dermaCwondV1EditDraftDiagnosticReport,
                    },
                    final: {
                        1: DiagnosticReportValidationTypes.dermaCwondV1EditFinalDiagnosticReport,
                    },
                },
            },
        },
    },
    [ServiceCode.DermaOth]: {
        [ServiceType.examination]: {
            [ReportCategories.examinationReport]: {
                add: {
                    draft: {
                        1: DiagnosticReportValidationTypes.dermaOthV1AddDraftDiagnosticReport,
                    },
                    final: {
                        1: DiagnosticReportValidationTypes.dermaOthV1AddFinalDiagnosticReport,
                    },
                },
                edit: {
                    draft: {
                        1: DiagnosticReportValidationTypes.dermaOthV1EditDraftDiagnosticReport,
                    },
                    final: {
                        1: DiagnosticReportValidationTypes.dermaOthV1EditFinalDiagnosticReport,
                    },
                },
            },
        },
    },
    [ServiceCode.OrthC]: {
        [ServiceType.consultation]: {
            [ReportCategories.consultReport]: {
                add: {
                    draft: {
                        1: DiagnosticReportValidationTypes.orthCV1AddDraftDiagnosticReport,
                    },
                    final: {
                        1: DiagnosticReportValidationTypes.orthCV1AddFinalDiagnosticReport,
                    },
                },
                edit: {
                    draft: {
                        1: DiagnosticReportValidationTypes.orthCV1EditDraftDiagnosticReport,
                    },
                    final: {
                        1: DiagnosticReportValidationTypes.orthCV1EditFinalDiagnosticReport,
                    },
                },
            },
        },
    },
    [ServiceCode.OCRK]: {
        [ServiceType.consultation]: {
            [ReportCategories.consultReport]: {
                add: {
                    draft: {
                        1: DiagnosticReportValidationTypes.ocrkV1AddDraftDiagnosticReport,
                    },
                    final: {
                        1: DiagnosticReportValidationTypes.ocrkV1AddFinalDiagnosticReport,
                    },
                },
                edit: {
                    draft: {
                        1: DiagnosticReportValidationTypes.ocrkV1EditDraftDiagnosticReport,
                    },
                    final: {
                        1: DiagnosticReportValidationTypes.ocrkV1EditFinalDiagnosticReport,
                    },
                },
            },
        },
    },
};

export function getDiagnosticReportValidationType(
    serviceCode: ServiceCode,
    serviceType: ServiceType,
    category: ReportCategories,
    version: number,
    addOrEdit: 'add' | 'edit',
    draftOrFinal: 'draft' | 'final'
) {
    return get(diagnosticReportValidationTypes, [serviceCode, serviceType, category, addOrEdit, draftOrFinal, version]);
}
